module.exports = "/assets/956028c177a5b245defa381256ad607a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/ZV.png
// module id = 3195
// module chunks = 0